<template>
  <v-container>
    <error-message ref="errorDialog" />
    <graph-title
      v-if="graph.graph_title"
      :title="graph.graph_title"
      class="pb-1"
    />
    <tag-bar v-if="graph.graph_tags" :tags="graph.graph_tags" class="pb-1" />
    <graph-image v-if="graph.xml_data" :imgURL="graph.xml_data" />
    <hr />
    <v-layout align-center justify-center row class="pt-3">
      <v-flex xs4 text-xs-center>
        <heart
          v-if="graph.graph_id"
          :heart="graph.heart_count"
          :graphId="graph.graph_id"
          :is_login="$store.state.twitter_account.is_login"
          :is_favorite="graph.is_favorite"
        />
      </v-flex>
      <v-flex xs4 text-xs-center>
        <share :share="graph.used_count" />
      </v-flex>
      <v-flex xs4 text-xs-center>
        <preview :preview="views" />
      </v-flex>
    </v-layout>
    <user-name
      v-if="
        graph.created_date &&
          graph.user.twitter_name &&
          graph.user.twitter_screen_name
      "
      :date="graph.created_date"
      :author="graph.user.twitter_name"
      :twitter="graph.user.twitter_screen_name"
    />
    <v-layout align-center justify-space-between row>
      <v-btn
        block
        v-if="!isOverwrite"
        class="mr-1 black--text font-weight-bold"
        color="primary"
        @click="drawTemplate"
        dark
        >テンプレートにする</v-btn
      >
      <v-btn
        block
        class="ml-1 black--text font-weight-bold"
        color="primary lighten-1"
        @click="drawOverwrite"
        >{{ overwriteText }}</v-btn
      >
    </v-layout>
    <v-layout justify-start>
      <collations
        v-if="
          (collations_count > 0 || isOverwrite) &&
            (graph.graph_id || graph.collate_graph_id)
        "
        :is_overwrite="isOverwrite"
        :graph_id="graph.graph_id"
        :collate_graph_id="graph.collate_graph_id"
      />
    </v-layout>
  </v-container>
</template>
<script>
import GraphTitle from "@/components/GraphTitleForDetail.vue";
import TagBar from "@/components/TagBarForDetail.vue";
import UserName from "@/components/UserNameForDetail.vue";
import GraphImage from "@/components/GraphImageForDetail.vue";
import Heart from "@/components/Heart.vue";
import Share from "@/components/Share.vue";
import Preview from "@/components/PreviewGraph.vue";
import Collations from "@/views/detail/Collations.vue";
import dayjs from "dayjs";
import ErrorMessage from "@/components/parts/ApiErrorMessage.vue";

export default {
  components: {
    GraphTitle,
    TagBar,
    UserName,
    GraphImage,
    Heart,
    Share,
    Preview,
    Collations,
    ErrorMessage
  },
  data() {
    return {
      graph: [],
      collations_count: 0,
      views: 0,
      overwriteText: "上書きする",
      isOverwrite: false
    };
  },
  watch: {
    $route(to, from) {
      this.getGraphDetail();
    }
  },
  methods: {
    updatePreview() {
      // 作成者でなければ閲覧数をカウントアップ
      if (this.graph.user_id != this.$store.state.login.user_id) {
        const apiUrl = "/v1/graphs/access/" + this.$route.params.id;
        this.$http
          .put(apiUrl)
          .then(res => {
            this.views = res.data.access_count;
          })
          .catch(error => {
            this.$refs.errorDialog.setMessage(
              "閲覧数の更新に失敗しました。詳細：[" +
                error.response.status +
                "] " +
                error.response.statusText
            );
          });
      } else {
        const apiUrl = "/v1/graphs/access/" + this.$route.params.id;
        this.$http
          .get(apiUrl)
          .then(res => {
            this.views = res.data.access_count;
          })
          .catch(error => {
            this.$refs.errorDialog.setMessage(
              "閲覧数の取得に失敗しました。詳細：[" +
                error.response.status +
                "] " +
                error.response.statusText
            );
          });
      }
    },
    getGraphDetail() {
      const apiUrl = "/v1/graphs/" + this.$route.params.id;

      return this.$http
        .get(apiUrl, {
          headers: {
            Authorization: "Bearer " + this.$store.state.login.auth_token
          }
        })
        .then(res => {
          this.graph = res.data;
          this.graph.graph_tags = this.setTag(res.data.graph_tags);
          this.graph.created_date = dayjs(res.data.created_date).format(
            "YYYY/MM/DD HH:mm:ss"
          );
          if (this.graph.collate_graph_id) {
            this.isOverwrite = true;
            this.overwriteText = "元になったグラフを見に行く";
          } else {
            this.isOverwrite = false;
            this.overwriteText = "上書きする";
          }
          this.updatePreview();
        })
        .catch(error => {
          this.$refs.errorDialog.setMessage(
            "グラフの取得に失敗しました。詳細：[" +
              error.response.status +
              "] " +
              error.response.statusText
          );
        });
    },
    setTag(tags) {
      const tag_list = [];
      for (const key in tags) {
        tag_list.push(tags[key].tag_name);
      }

      return tag_list;
    },
    drawTemplate() {
      this.$store.commit("setGraphType", "template");
      this.$router.push({ name: "create", query: { id: this.graph.graph_id } });
    },
    drawOverwrite() {
      if (this.graph.collate_graph_id) {
        this.$router.push({
          name: "detail",
          params: { id: this.graph.collate_graph_id }
        });
      } else {
        this.$router.push({
          name: "overwrite",
          query: { id: this.graph.graph_id }
        });
      }
    },
    getCollationsGraph() {
      const EP = "/v1/graphs/collations/" + this.graph.graph_id;
      this.$http
        .get(EP, {
          headers: {
            Authorization: "Bearer " + this.$store.state.login.auth_token
          }
        })
        .then(res => {
          this.collations_count = res.data.length;
        })
        .catch(error => {
          this.$refs.errorDialog.setMessage(
            "関連グラフの取得に失敗しました。詳細：[" +
              error.response.status +
              "] " +
              error.response.statusText
          );
        });
    }
  },
  async mounted() {
    await this.getGraphDetail();
    if (!this.isOverwrite) {
      this.getCollationsGraph();
    }
  }
};
</script>
<style lang="scss" scoped>
hr {
  margin: auto;
  $color: orange;
  color: $color;
  border-width: 0 0 4px;
  border-style: solid;
  border-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2 1" width="8" height="4"><circle fill="#{$color}" cx="1" cy="0.5" r="0.5"/></svg>')
    0 0 100% repeat;
}
</style>
